import React from 'react';
import faker from 'faker';

import {SideHeader, TabMenu} from './components';
import UserDetails from '../UserDetails';
import styles from './MenuSidebar.module.scss';
import Button from '../Button';
// import {useQuery} from '@apollo/client';

// import {FOLLOWINGS_QUERY} from './graphql/FollowingsQuery';
// import {getFollowings} from './graphql/types/getFollowings';
import {UserStatus} from '../../types';

export interface getFollowings_getFollowings {
  __typename: 'User';
  username: string;
  firstName: string;
  lastName: string;
  photo: string;
  id: string;
}

const mockFollowings: {getFollowings: getFollowings_getFollowings[]} = {
  getFollowings: [
    {
      __typename: 'User',
      username: 'calum',
      firstName: 'Calum',
      lastName: 'Patrick',
      photo:
        'https://avatars1.githubusercontent.com/u/3886060?s=460&u=18b8287ba20f9f4b4adc9daf423f7bc197509c11&v=4',
      id: faker.random.number().toString(),
    },
    {
      __typename: 'User',
      username: 'stefano',
      firstName: 'Stefano',
      lastName: 'Savvidis',
      photo:
        'https://avatars0.githubusercontent.com/u/25650518?s=460&u=9654663dec340a7268889ac02f591d6f69875327&v=4',
      id: faker.random.number().toString(),
    },
    {
      __typename: 'User',
      username: 'emma',
      firstName: 'Emma',
      lastName: 'Orhun',
      photo: 'https://avatars2.githubusercontent.com/u/31415327?s=460&v=4',
      id: faker.random.number().toString(),
    },
    {
      __typename: 'User',
      username: 'owen',
      firstName: 'Owen',
      lastName: 'Craston',
      photo:
        'https://avatars2.githubusercontent.com/u/22918444?s=460&u=4d915f9d8f34413234ada36af0fd2c42aa1c75d2&v=4',
      id: faker.random.number().toString(),
    },
    {
      __typename: 'User',
      username: 'nick',
      firstName: 'Nick',
      lastName: 'Ellul',
      photo:
        'https://avatars0.githubusercontent.com/u/15018469?s=460&u=336da17b79e808a76fad97712f43094b412015e7&v=4',
      id: faker.random.number().toString(),
    },
  ],
};

export default function MenuSidebar() {
  // TODO: Replace mock data with query (0.2)
  // const {data: followingsQueryData} = useQuery<getFollowings>(FOLLOWINGS_QUERY);
  // const followings = followingsQueryData && followingsQueryData.getFollowings;
  const followings = mockFollowings.getFollowings;
  const followingsMarkup =
    followings && followings.length > 0
      ? followings.map(({firstName, lastName, photo, id}, index) => {
          // TODO: Add friends to context, determine when to requery freinds (possibly on timer for status changes)
          // TODO: Sort by status
          const listening = faker.random.boolean();
          const mockStatus = Object.values(UserStatus)[
            Math.floor(Math.random() * 5)
          ];
          const mockSongName = faker.company.catchPhrase();
          const mockSongArtist = faker.company.companyName();
          const displayName = `${firstName} ${lastName}`;
          return (
            <UserDetails
              key={id}
              mainText={listening ? mockSongName : displayName}
              subtitleText={listening ? mockSongArtist : mockStatus}
              headerText={listening ? displayName : undefined}
              status={mockStatus}
              profilePhoto={photo}
            />
          );
        })
      : null;

  return (
    <div className={styles.MenuSidebar}>
      <SideHeader />
      <TabMenu />
      <div className={styles.FriendsWrapper}>
        <div className={styles.FriendsHeader}>Friend Activity</div>
        <div className={styles.Friends}>
          <ol className={styles.FriendsList}>
            {(followingsMarkup || []).sort((a, b) => {
              // TODO: Bad temporary friend sort :) remove bad
              if (
                a.props.status === UserStatus.Hosting ||
                a.props.status === UserStatus.Connected
              ) {
                return -1;
              } else {
                return 0;
              }
            })}
          </ol>
          <div className={styles.ButtonWrapper}>
            <Button fill shadow onClick={() => {}}>
              Add Friends
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
